module.exports = __webpack_public_path__ + "static/img/vod-bn-9.9510494.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vod-bn-9.jpg
// module id = 31Zh
// module chunks = 1